import Auth from '../../services/auth'
import Accordion from '../../components/accordion/accordion.vue'
import Account from '../../services/account'
export default {
    data(){
      return {
        state: undefined,
        loading: undefined,
        notifications: undefined
      }
    },
    mounted(){
      
      this.state = 'LOADING';
      this.loading = Account.getNotification().then(resp => {
        this.notifications = resp;
        
      })
    },
    components: {
      Accordion
    }

}


// WEBPACK FOOTER //
// ./src/pages/account/notification.js